import { Component } from 'react';
import { compose } from 'redux';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import {
  combineStyles,
  isGranted,
  translateNamesForExport,
} from 'helpers/helpers';
import {
  ROLE_CREATE_IMPORTER_TASK,
  ROLE_CREATE_ZONE,
  ROLE_SHOW_IMPORTER_TASK,
  ROLE_IMPORT_ZONE,
  ROLE_REMOVE_ZONE,
} from 'helpers/roles';
import Button from 'components/CustomButtons/Button';
import InfoModal from 'components/InfoModal/InfoModal';
import MediaUpload from 'components/MediaUpload/MediaUpload';
import gastro from 'helpers/gastro';
import { post } from 'helpers/apiHelpers';
import { Trans, withTranslation } from 'react-i18next';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { remove } from 'helpers/apiHelpers';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Dialog } from '@material-ui/core';
import { toast } from 'react-toastify';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { connect } from 'react-redux';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Tooltip from '@material-ui/core/Tooltip';

import ListHeader from './ListHeader';
import { DialogLoader } from '../../../../components/DialogLoader';
import importCSVExample from './import-xlsx-example.xlsx';
import columnConfig from './columnConfig';
import PROVIDERS from '../constants/providers';

const customClasses = {
  modalList: { textAlign: 'left' },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  checkboxTitle: { paddingRight: '0!important', paddingLeft: '0!important' },
  checkbox: {
    padding: '0!important',
  },
  importButton: { margin: '5px', width: '158px' },
  strongColor: { color: grayColor[16] },
  headerCheckboxWrapper: {
    marginTop: '-15px',
  },
  deleteIconTooltip: {
    opacity: 0.5,
  },
};

const EXPORT_DETAIL_MANIPULATOR = ({ name, shortName, ...rest }) => {
  const query = { ...rest, 'zone.name': name, 'zone.shortName': shortName };

  return Object.keys(query).reduce((prev, curr) => {
    if (query[curr]) {
      prev[curr] = query[curr];
    }
    return prev;
  }, {});
};

const checkIsGoodspeedZone = (zone, autoSyncEnabled) =>
  autoSyncEnabled && zone.provider === PROVIDERS.GOODSPEED;

const getCustomActions = ({ row, t, autoSyncEnabled, setState }) => {
  if (!isGranted(ROLE_REMOVE_ZONE)) {
    return [];
  }

  const isGoodspeedZone = checkIsGoodspeedZone(row, autoSyncEnabled);

  return [
    {
      action: () => {
        if (isGoodspeedZone) {
          return;
        }

        setState(prevState => ({
          ...prevState,
          deleteModalType: 'single',
          zonesIds: [row.id],
        }));
      },
      icon: isGoodspeedZone ? (
        <Tooltip
          style={customClasses.deleteIconTooltip}
          title={t('zones.cannotDeleteGoodspeedZoneTooltip')}
        >
          <DeleteForeverIcon />
        </Tooltip>
      ) : (
        <DeleteForeverIcon />
      ),
      color: 'danger',
      simple: true,
      round: false,
    },
  ];
};

class List extends Component {
  state = {
    openedModal: false,
    file: null,
    isImporting: false,
    importButtonClicked: false,
    zonesIds: [],
    numberOfZones: null,
    refreshList: false,
    isDeleting: false,
    deleteModalType: null,
    allZoneIds: [],
  };

  componentDidMount() {
    const successfullyAddedZone =
      !!this.props.location.state?.successfullyAddedZone;
    const zoneCostCompleted = !!this.props.location.state?.zoneCostCompleted;

    if (successfullyAddedZone && !zoneCostCompleted) {
      toast.warning(this.props.t('zones.rememberToCompletePriceList'));
    }
  }

  newZone = () => this.props.history.push(`${window.location.pathname}/add`);

  closeModal = () => {
    this.setState({
      openedModal: false,
    });
  };

  openModal = () => {
    this.setState({
      openedModal: true,
    });
  };

  importZones = () => {
    this.setState({ importButtonClicked: true });
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    this.uploadFile(this.state.file).then(file => {
      this.postImporterTask(file);
    });
  };

  postImporterTask = file => {
    this.setState({ isImporting: true });
    const data = {
      type: 'ZONES',
      file: file['@id'],
      config: {
        skipHeader: true,
        delimiter: ';',
      },
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    post('/importer-tasks', data).then(
      () => {
        this.setState({
          openedModal: false,
          file: null,
          importButtonClicked: false,
        });
        this.setState({ isImporting: false });
        return toast.success(
          `${this.props.t('zones.importAdded')} ${this.props.t(
            'zones.refreshPage'
          )}`
        );
      },
      () => {
        this.setState({ isImporting: false });
        return toast.error(this.props.t('zones.cannotImport'));
      }
    );
  };

  // eslint-disable-next-line class-methods-use-this -- FIXME
  uploadFile = async file => {
    const data = new FormData();
    data.append('file', file);

    const response = await gastro.post('/media', data);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    return new Promise((resolve, reject) => {
      resolve(response.data);
    });
  };

  setNumberOfZones = zones => {
    this.setState(prevState => ({
      ...prevState,
      numberOfZones: zones.length,
      zonesIds: zones.length > 0 ? prevState.zonesIds : [],
      allZoneIds: zones
        .filter(zone => !checkIsGoodspeedZone(zone, this.props.autoSyncEnabled))
        .map(zone => zone.id),
    }));
  };

  massDeleteHandleSingleCheckbox = id => {
    const zonesIdsUpdated = [...this.state.zonesIds];
    const zoneIdIndex = zonesIdsUpdated.indexOf(id);

    if (zoneIdIndex >= 0) {
      zonesIdsUpdated.splice(zoneIdIndex, 1);
    } else {
      zonesIdsUpdated.push(id);
    }

    this.setState(prevState => ({ ...prevState, zonesIds: zonesIdsUpdated }));
  };

  massDeleteHandleMultipleCheckboxes = array => {
    const { allZoneIds } = this.state;
    const filtered = array.filter(id => allZoneIds.includes(id));
    this.setState(prevState => ({ ...prevState, zonesIds: filtered }));
  };

  massDeleteZonesSubmit = async () => {
    this.setState(prevState => ({
      ...prevState,
      deleteModalType: null,
    }));

    let url;
    if (this.state.zonesIds.length === this.state.numberOfZones) {
      url = '/zones?removeAllAction=true';
    } else {
      url = '/zones?';
      this.state.zonesIds.forEach((zoneId, index) => {
        if (index === 0) {
          url = url.concat(`id[]=${zoneId}`);
        } else {
          url = url.concat(`&id[]=${zoneId}`);
        }
      });
    }

    this.setState(prevState => ({ ...prevState, isDeleting: true }));

    try {
      await remove(url);
      this.refreshList();
      toast.success(this.props.t('zones.toastMessage.chosenZonesWereDeleted'));
    } catch {
      toast.warning(
        this.props.t('zones.toastMessage.chosenZonesWereNotDeleted')
      );
    } finally {
      this.setState(prevState => ({
        ...prevState,
        isDeleting: false,
        zonesIds: [],
      }));
    }
  };

  singleDeleteZoneSubmit = async () => {
    this.setState(prevState => ({
      ...prevState,
      deleteModalType: null,
      isDeleting: true,
    }));

    try {
      await remove(`/zones/${this.state.zonesIds[0]}`);
      this.refreshList();
      toast.success(this.props.t('zones.toastMessage.chosenZonesWereDeleted'));
    } catch {
      toast.warning(this.props.t('zones.toastMessage.zoneWasNotDeleted'));
    } finally {
      this.setState(prevState => ({
        ...prevState,
        deleteModalType: null,
        isDeleting: false,
        zonesIds: [],
      }));
    }
  };

  closeDeleteConfirmModal = () => {
    this.setState(prevState => ({
      ...prevState,
      deleteModalType: null,
      zonesIds:
        prevState.deleteModalType === 'single' ? [] : prevState.zonesIds,
    }));
  };

  refreshList = () => {
    this.setState(prevState => ({ refreshList: !prevState.refreshList }));
  };

  render() {
    const { classes, t } = this.props;
    const namesForExport = translateNamesForExport(t);
    return (
      <>
        <DialogLoader loaderState={this.state.isDeleting} />
        <AdminTable title={<ListHeader />}>
          <InfoModal
            modalState={this.state.openedModal}
            handleClose={() => this.setState({ openedModal: false })}
            modalContent={
              <div>
                <h1>{t('zones.zonesImport')}</h1>
                <ul className={classes.modalList}>
                  <Trans
                    i18nKey="zones.importerModal"
                    components={{
                      li: <li />,
                      strong: <strong className={classes.strongColor} />,
                      a: (
                        <a
                          href={importCSVExample}
                          download={`${t('zones.importerModal.fileName')}.xlsx`}
                        />
                      ),
                    }}
                  />
                </ul>
                <MediaUpload
                  file={this.state}
                  setFile={file => this.setState({ file })}
                  buttonText={t('zones.selectXLSXFile')}
                  addButtonProps={{
                    color: 'info',
                    round: false,
                  }}
                  changeButtonProps={{
                    color: 'info',
                    round: false,
                  }}
                  removeButtonProps={{
                    color: 'danger',
                    round: false,
                  }}
                />
                <div>
                  {isGranted(ROLE_CREATE_IMPORTER_TASK) &&
                    isGranted(ROLE_IMPORT_ZONE) && (
                      <Button
                        color={this.state.file ? 'success' : 'default'}
                        disabled={
                          !this.state.file ||
                          this.state.isImporting ||
                          this.state.importButtonClicked
                        }
                        onClick={this.importZones}
                      >
                        {t('zones.import')}
                      </Button>
                    )}
                  <Button onClick={this.closeModal}>{t('zones.close')}</Button>
                </div>
              </div>
            }
            closeButtonText={t('zones.close')}
            hideDefaultCloseButton={true}
          />
          <div className={classes.buttonsWrapper}>
            {isGranted(ROLE_SHOW_IMPORTER_TASK) &&
              isGranted(ROLE_IMPORT_ZONE) && (
                <Button
                  data-cy="__import_zone_button"
                  className={classes.importButton}
                  color="info"
                  onClick={this.openModal}
                >
                  {t('zones.import')}
                </Button>
              )}
            {isGranted(ROLE_REMOVE_ZONE) && (
              <Button
                data-cy="__remove_zone_button"
                color="danger"
                onClick={() =>
                  this.setState(prevState => ({
                    ...prevState,
                    deleteModalType: 'mass',
                  }))
                }
                disabled={this.state.zonesIds.length === 0}
              >
                {t('zones.deleteZones', 'Usuń strefy')}
              </Button>
            )}
            {isGranted(ROLE_CREATE_ZONE) && (
              <FormControlButtons
                classes={classes}
                handleSubmit={this.newZone}
                submitText={`${t('zones.addZone')} +`}
              />
            )}
          </div>
          <DataGrid
            refresh={this.state.refreshList}
            actions={true}
            customActions={row =>
              getCustomActions({
                row,
                t,
                autoSyncEnabled: this.props.autoSyncEnabled,
                setState: this.setState.bind(this),
              })
            }
            editPath={`${window.location.pathname}/edit`}
            export={true}
            paginationTop={true}
            paginationBottom={false}
            url="/zones"
            reportName="zone"
            columns={columnConfig({
              t: this.props.t,
              classes,
              state: this.state,
              massDeleteHandleSingleCheckbox:
                this.massDeleteHandleSingleCheckbox,
              massDeleteHandleMultipleCheckboxes:
                this.massDeleteHandleMultipleCheckboxes,
              allIds: this.state.allZoneIds,
              checkIsGoodspeedZone,
              autoSyncEnabled: this.props.autoSyncEnabled,
            })}
            role="ZONE"
            manipulateQuery={(table, query) => {
              query.properties = [
                'id',
                'name',
                'shortName',
                'category',
                'drivers',
                'postCodesLength',
                'deliveryType',
                'deliveryHours',
                'priority',
                'provider',
              ];
              query['properties[category]'] = ['name'];
              query['properties[drivers]'] = ['name'];
              query['properties[deliveryType]'] = ['value'];
              query['properties[deliveryHours]'] = ['hourFrom', 'hourTo'];

              return query;
            }}
            exportButtonConfig={[
              {
                label: `XLSX - ${this.props.t('common.details')}`,
                format: 'xlsx',
                endpoint: '/zones',
                fileName: (url, date) =>
                  namesForExport[url] ? namesForExport[url] + date : url + date,
              },
              {
                label: `CSV - ${this.props.t('common.details')}`,
                format: 'csv',
                endpoint: '/zones',
                fileName: (url, date) =>
                  namesForExport[url] ? namesForExport[url] + date : url + date,
              },
              {
                label: 'XLSX',
                format: 'xlsx',
                endpoint: '/zone-post-codes-export',
                fileName: (url, date) =>
                  namesForExport[url] ? namesForExport[url] + date : url + date,
                manipulateQuery: EXPORT_DETAIL_MANIPULATOR,
              },
              {
                label: 'CSV',
                format: 'csv',
                endpoint: '/zone-post-codes-export',
                fileName: (url, date) =>
                  namesForExport[url] ? namesForExport[url] + date : url + date,
                manipulateQuery: EXPORT_DETAIL_MANIPULATOR,
              },
            ]}
            onFetchedData={this.setNumberOfZones}
          />
        </AdminTable>

        <Dialog fullWidth={true} open={Boolean(this.state.deleteModalType)}>
          <SweetAlert
            warning={true}
            style={{ display: 'block' }}
            title={t('common.shared.areYouSure')}
            onConfirm={
              this.state.deleteModalType === 'mass'
                ? this.massDeleteZonesSubmit
                : this.singleDeleteZoneSubmit
            }
            onCancel={this.closeDeleteConfirmModal}
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnCssClass={`${classes.button} ${classes.danger}`}
            confirmBtnText={t('common.shared.yes')}
            cancelBtnText={t('common.shared.no')}
            showCancel={true}
          />
        </Dialog>
      </>
    );
  }
}

const combinedStyles = combineStyles(buttonsStyle, customClasses);

const enhance = compose(
  withStyles(combinedStyles),
  withTranslation(),
  connect(({ Brands: { brand } }) => ({
    autoSyncEnabled: brand.autoSyncEnabled,
  }))
);

export default enhance(List);
